<template>
    <div class="d-flex flex-column w-100">
        <child-appearance-log-item v-for="appearanceLog in childLoggableAppearances"
                                   :key="appearanceLog.id + 'log'" :status="appearanceLog"
                                   :show-details="fullDetails"/>
        <p v-if="!lastStatus" class="fw-bold mb-1 text-gray-500">{{ trans('general.module.attendance.pending') }}</p>
    </div>
</template>

<script>
import ChildAppearanceLogItem from "./ChildAppearanceLogItem.vue";

export default {
    components: {ChildAppearanceLogItem},
    props: {
        appearances: {
            type: Array,
            required: true
        },
        fullDetails: {
            type: Boolean,
            required: false,
            default: true
        },
        dailyReport: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    watch: {
        appearances() {
            if (this.appearances.length > 0) {
                this.$emit('status', this.appearances[this.appearances.length - 1].type);
            } else {
                this.$emit('status', 'pending');
            }
        }
    },
    computed: {
        lastStatus() {
            return this.appearances[this.appearances.length - 1] ?? null;
        },
        loggableStatuses() {
            const logFilter = {
                missing: ['missing'],
                check_in: ['check_in'],
                check_out: ['check_in', 'check_out'],
                pending: ['missing']
            }

            return logFilter[this.lastStatus.type] ?? [];
        },
        childLoggableAppearances() {
            return this.appearances.filter((appearance) => this.loggableStatuses.includes(appearance.type));
        }
    },
    mounted() {
        if (!this.lastStatus) {
            this.$emit('status', 'pending');
        }
    }
}
</script>
